import {Badge} from 'react-bootstrap'

const COLORS: Record<string, string> = {
  DRAFT: 'secondary',
  ACTIVE: 'success',
  INACTIVE: 'warning',
  PENDING: 'warning',
  PARTIAL: 'info',
  COMPLETED: 'success',
  VOIDED: 'danger',
  EXPIRED: 'secondary',
  VIEWED: 'info',
  SIGNED: 'success',
}

export const BadgeStatus = ({state}: {state: string}) => {
  return <Badge bg={COLORS[state] ?? 'secondary'} style={{color: '#fff'}}>{state}</Badge>
}
